import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Form, Col } from 'react-bootstrap';
import TimerClock from './timer';
import acAnimated from "../hupUtils/splitText";

const timeoutLength = 150;

acAnimated.randomNumber = function (min, max) {
    var num = min + Math.floor(Math.random() * (max - (min - 1)));
    return num;
}
acAnimated.randomDirection = function (number) {
    var direction = Math.floor(Math.random() * 2);
    if (direction === 0) number = 0 - number;
    return number;
}
acAnimated.animateChar = function (char) {
    var timeline = new window.TimelineMax({});
    timeline.from(char, acAnimated.randomNumber(3, 5) / 10, { top: acAnimated.randomDirection(acAnimated.randomNumber(10, 50)), rotationZ: acAnimated.randomDirection(acAnimated.randomNumber(90, 360)), rotationX: acAnimated.randomDirection(acAnimated.randomNumber(90, 360)), opacity: 0 });
    return timeline;
}
acAnimated.animateWord = function (word) {
    var timeline = new window.TimelineMax({});
    timeline.from(word, acAnimated.randomNumber(3, 5) / 10, { top: acAnimated.randomDirection(acAnimated.randomNumber(10, 50)), rotationX: acAnimated.randomDirection(acAnimated.randomNumber(90, 360)), opacity: 0 });
    return timeline;
}

class efect2 extends React.Component {

    state = {
        inputTest: null,
        textAux: 'Completa la respuesta'
    }

    randomMax(min, max) {
        return (Math.random() * (max - min)) + min;
    }
    
    handlePaso = () => {
        this.timeout = setTimeout(() => {
            let text = document.body.querySelector(".text");
            const split = acAnimated.Plugins.SplitText(text, { words: 1, chars: 1, spacing: 10 });
            let timeline = null;
            let i;
            switch ( Math.round(Math.random() * 3)) {
               // switch (this.props.tipo) {
                case 0:
                    timeline = new window.TimelineMax({ repeat: 5, repeatDelay: 5 });
                    for (i = 0; i <= split.chars.length - 1; i++) {
                        var char = split.chars[i];
                        timeline.add("animated_char_" + String(i), acAnimated.randomNumber(1, 20) / 10);
                        timeline.add(acAnimated.animateChar(char), "animated_char_" + String(i));
                    }
                    timeline.to(text, 3, {}).to(text, 1, { opacity: 0 });
                    timeline.duration(10)
                    break;
                case 1:
                    timeline = new window.TimelineMax({ repeat: 5, repeatDelay: 5 });
                    for (i = 0; i <= split.words.length - 1; i++) {
                        var word = split.words[i];
                        timeline
                            .add("animated_word_" + String(i), acAnimated.randomNumber(1, 20) / 10)
                            .add(acAnimated.animateWord(word), "animated_word_" + String(i));
                    }
                    timeline.to(text, 3, {}).to(text, 1, { opacity: 0 });
                    timeline.duration(10)
                    break;
                case 2:
                    for (i = 0; i <= split.chars.length - 1; i++) {
                        window.TweenMax.from(split.chars[i], 1.8, {
                            opacity: 0,
                            x: this.randomMax(-100, 100),
                            y: this.randomMax(-100, 100),
                            z: this.randomMax(-100, 100),
                            scale: .1,
                            delay: i * .05,
                            yoyo: false,
                            repeat: 5,
                            repeatDelay: 10
                        });
                    };
                    break;
                case 3:
                    for (i = 0; i <= split.words.length - 1; i++) {
                        window.TweenMax.from(split.words[i], 1.8, {
                            opacity: 0,
                            x: this.randomMax(-100, 100),
                            y: this.randomMax(-100, 100),
                            z: this.randomMax(-100, 100),
                            scale: 1,
                            delay: i * .2,
                            yoyo: false,
                            repeat: 5,
                            repeatDelay: 10
                        });
                    };
                    break;

                default:
                    break;
            }


        }, timeoutLength)
    }


    btOptionsShortCuts(shortCuts) {
        const opciones = Object.keys(shortCuts).map((key, index) => {
            return <span> <h5 href="#" onClick={() => this.nexMessage(shortCuts[key].label)} className="action-button animate purple" key={key} >{shortCuts[key].label}</h5></span>
        });
        return opciones;
    }

    nexMessage(e) {

    }

    selectFunctions(cases, obj) {

    }

    btImputText(text, next) {

        return <div>

            <Row className='btIlnputTextChat2'>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 10, offset: 1 }}>

                    <Form  >
                        <span>
                            <Form.Group controlId="ControlInput1">
                                <Form.Control name="code"
                                    type="text" required value={this.state.inputTest}
                                    onChange={(event) => this.setState({ inputTest: event.target.value })}
                                    onKeyPress={(e) => { this.nexMessage(e) }} placeholder={text.placeholder} />
                                <Form.Control.Feedback>{this.state.textAux}</Form.Control.Feedback>
                            </Form.Group>
                        </span>

                    </Form>

                </Col>
            </Row>

            {next ? this.btContinuar() : null}

        </div>

    }

    btImputOptions(options, add, cases, next) {
        let opt = null;
        let addOption = null;

        if (options) {
            opt = Object.keys(options).map((key, index) => {
                if (key === 0)
                    return <option selected style='pruebaColor'>{options[key].label}</option>

                return <option value={options[key].id}>{options[key].label}</option>
            });
        }

        if (add)
            addOption = <Row>
                <Col md={{ span: 6, offset: 4 }} xs={{ span: 2, offset: 2 }}>
                    <span>  <h5 href="#" onClick={(e) => { this.nexMessage(e, add) }} className="action-button animate purple2 btIlnputNextChat" key={2} >{add}</h5> </span>
                </Col>
            </Row>




        return <div>
            <Row className='btIlnputTextChat2'>
                <Col md={{ span: 4, offset: 4 }} xs={{ span: 10, offset: 1 }}>

                    <Form  >
                        <span>
                            <Form.Group controlId="ControlInputC1">
                                <Form.Control as="select"
                                    value={this.state.inputTest}
                                    onChange={(e) => { this.setState({ inputTest: e.target.value }); this.selectFunctions(cases, this.state.inputTest); }}
                                >
                                    {opt}
                                </Form.Control>
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                        </span>

                    </Form>

                </Col>
            </Row>

            {addOption}
            {next ? this.btContinuar() : null}

        </div>
    }

    btContinuar() {
        return <Row>
            <Col md={{ span: 6, offset: 4 }} xs={{ span: 2, offset: 2 }}>
                <span>  <h5 href="#" onClick={(e) => { this.nexMessage(e) }} className="action-button animate purple btIlnputNextChat" key={2} >Continuar</h5> </span>
            </Col>
        </Row>
    }
    bttimeClock(next) {

        return (<div className='btFlushtimer'>
            <Row>
                <Col md={{ span: 3, offset: 4 }} xs={{ span: 6 }}>
                    <TimerClock programa={true}></TimerClock>
                </Col>
            </Row>
            {next ? this.btContinuar() : null}

        </div>);
    }

    render() {

        this.handlePaso();
        const text = { placeholder: 'Escribe tu respuesta' };
        const prueba = [
            { key: '1', label: 'opcion 1' },
            { key: '2', label: 'opcion 2' },
            { key: '3', label: 'opcion 3' },
            { key: '4', label: 'opcion 4' },
        ];
        const optionsTest = [
            { id: '0', label: 'Selecciona tu objetivo' },
            { id: '1', label: 'opcion 1' },
            { id: '2', label: 'opcion 2' },
            { id: '3', label: 'opcion 3' },
            { id: '4', label: 'opcion 4' },
        ];

        return (
            <div className="sp-container">
                <div className="sp-content">
                    <div className="sp-globe"></div>
                    <h2 className="frame-1 h2-efect2"> 
                    <div className='text textBot' id='text' >
                            <p className="split"  >
                                {this.props.messageBot}
                            </p>
                        </div> 
                    </h2>

                    {/*    <h2 className="frame-1 h2-efect2">PRODUCTIVIDAD</h2>
                    <h2 className="frame-2 h2-efect2">MAS TIEMPO LIBRE</h2>
                    <h2 className="frame-3 h2-efect2">EFICIENCIA</h2>
                    <h2 className="frame-4 h2-efect2">CON TU COMPAÑERO EN EL TRBAJO!</h2>*/}
                    <h2 className="frame-2 h2-efect2">
                        {this.btImputOptions(optionsTest, 'Agregar tarea', null, true)}
                        {/*this.btImputText(text)*/}
                        {/*this.bttimeClock(true)*/}

                    </h2>

                </div>
            </div>

        );
    }
};

const mapAppStateToProps = (state) => (
    {

    });


export default connect(mapAppStateToProps, {})(efect2);